export const CX_DD_DIFFRENCE_GO_BUTTON_ACTION = 'CX_DD_DIFFRENCE_GO_BUTTON_ACTION'
export const CX_DD_DIFFRENCE_GO_BUTTON_SUCCESS = 'CX_DD_DIFFRENCE_GO_BUTTON_SUCCESS'

export const CX_DD_DIFFRENCE_REPORT_API_ERROR_ACTION = 'CX_DD_DIFFRENCE_REPORT_API_ERROR_ACTION'